import { useEffect, useRef } from 'react';

export function usePolling(
  callback: () => void,
  interval: number,
  enabled: boolean
) {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!enabled) return;

    intervalRef.current = setInterval(callback, interval);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [enabled, interval, callback]);
}
